// extracted by mini-css-extract-plugin
module.exports = {"error-fallback":"ErrorFallbackView_error-fallback__3td6J","additional-message":"ErrorFallbackView_additional-message__1OImV"};